import { doc, getDoc } from 'firebase/firestore';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { db } from '../firebase';
import { User } from '../models/user';

export const useUser = (userId: string) => {
  const userRef = useMemo(() => doc(db, 'users', userId), [userId]);

  const { data: user } = useQuery(`/user/${userId}`, async () => {
    const snapshot = await getDoc(userRef);
    if (snapshot.exists()) {
      return snapshot.data() as User;
    }
    return null;
  });

  return user;
};
